import { useTranslation } from 'react-i18next';
import { hasRelatedPurchaseOrders } from '@/features/lot-sizing/has-related-purchase-orders';
import { LotSizingCreatePurchaseOrder } from '@/features/lot-sizing/lot-sizing-create-purchase-order';
import { useGetLotSizing } from '@/services/apis/queries/lot-sizing/use-get-lot-sizing';
import { LotSizingWithPurchaseOrderCancel } from './lot-sizing-with-purchase-order-cancel';
import { LotSizingWithPurchaseOrderSave } from './lot-sizing-with-purchase-order-save';

type LotSizingHeaderProps = {
  id: string;
};

export function LotSizingHeader({ id }: LotSizingHeaderProps) {
  const { data: lotSizing } = useGetLotSizing(id);
  const { t } = useTranslation('lotSizing');

  const title = `${t('title')} - ${lotSizing.name}`;

  const allNonEligibleForUpdate = lotSizing.purchaseOrders.every(
    (po) => !po.isEligibleForEditionOrSync,
  );

  return (
    <div className='flex items-center justify-between'>
      <h1 className='font-semibold text-2xl'>{title}</h1>
      <div className='flex items-center gap-2'>
        {hasRelatedPurchaseOrders(lotSizing) && (
          <>
            <LotSizingWithPurchaseOrderSave
              disabled={allNonEligibleForUpdate}
              lotSizingId={id}
            />
            <LotSizingWithPurchaseOrderCancel />
          </>
        )}
        <LotSizingCreatePurchaseOrder lotSizing={lotSizing} />
      </div>
    </div>
  );
}
